import useSWR from 'swr';

import { useSnackbar } from '~/lib/hooks/useSnackbar';
import { augmentSWR, swrKeyFor } from '~/lib/swr';
import { ProblemFromSWR } from '../problemPreview';

interface Config {
  problemId?: string;
  studentInTestId?: string;
}

export const useExamProblem = ({
  problemId,
  studentInTestId,
}: Config): ProblemFromSWR => {
  const { enqueueGenericError } = useSnackbar();
  const swrKey = swrKeyFor(() =>
    problemId ? ['examProblems.show', problemId, studentInTestId] : null,
  );

  return useSWR<Response>(swrKey, {
    onError: () => enqueueGenericError(),
    use: [augmentSWR('problemData', ({ data }) => data)],
  }) as ProblemFromSWR;
};
